<template>
    <div class="button-container" v-if="mapLink != null">
        <a :href="mapLink" target="_blank" class="button is-primary">{{ $t("common.viewMapPortalButtonText")}}</a>
    </div>
</template>
<script setup>
import { computed, defineProps } from 'vue'
import { useApp } from '@/composables/state/profileState';

const { mapLayers, aoiData } = useApp();
const props = defineProps(['mapConfig', 'mapLayers']);
// ?&aoi=69&dataset=34044,34042,34041,34046,34043,34045,&mask=69

const mapLink = computed(() => {
  if (mapLayers.length > 0) {
    const link = {};
    link.aoi = aoiData.aoiId;
    link.dataSet = [];

    props.mapConfig.forEach((map, index) => {
      const layerId = mapLayers.filter(x => map.name?.includes(x.name)).map(x => { return { mapId: x.id + '', toShow: true }; });
      if (layerId) {
        layerId.forEach(x => { link.dataSet.push(x.mapId); });
      }
    });
    return import.meta.env.VITE_APP_MAP_PORTAL_URL + `aoi=${link?.aoi}&dataset=${link?.dataSet?.join(',')}`;
  }
  return null;
});
</script>
<style lang="scss" scoped>
.button-container {
    padding-top: 0;
    a {
        font-size: .6rem;
        height: 2rem;
        min-height: 2rem;
        padding: 0.5rem 1rem;
        margin-top: 1rem;
    }
}

</style>
